<app-header></app-header>

<ion-content
  *ngIf="(allInventoriesPageData$ | async) as allInventoriesPageData"
  id="all-inventories"
  class="gray-content-bg"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
>
  <cdk-virtual-scroll-viewport
    appInvVs
    [indexOffset]="1"
    [itemHeights]="allInventoriesPageData?.itemHeights"
    [bufferBefore]="20"
    [bufferAfter]="20"
  >
    <!-- Desktop Page Header -->
    <div
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      data-cy="all-inventories-header"
      class="all-inventories-header"
    >
      <ion-grid [fixed]="true">
        <!-- Breadcrumbs -->
        <ion-row
          data-cy="all-inventories-breadcrumbs-row"
          class="all-inventories-breadcrumbs"
        >
          <ion-col data-cy="all-inventories-breadcrumbs-column" size="12">
            <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
          </ion-col>
        </ion-row>
        <!-- Page Title -->
        <ion-row data-cy="all-inventories-page-title-row">
          <ion-col data-cy="all-inventories-page-title-row" size="12">
            <h2
              data-cy="all-inventories-page-title-text"
              class="all-inventories-title"
            >
              {{ 'i18n.inventory.inventoryAllTitle' | translate | uppercase}}
            </h2>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <ion-grid
      data-cy="all-inventories-content"
      class="all-inventories-content"
      [class.hide]="!allInventoriesPageData?.isInventoryDataLoaded"
      [fixed]="true"
    >
      <!-- Desktop/Tablet -->
      <ng-container
        *ngIf="platformService?.platformType !== platformService?.platformEnum?.mobile; else mobileAllInventories"
      >
        <!-- Searchbar, Create New Inventory Button, View Completed Toggle -->
        <ion-row
          data-cy="all-inventories-search-create-completed-row"
          class="ion-align-items-center"
        >
          <ion-col data-cy="all-inventories-search-column" size="9">
            <div class="all-inventories-search-create">
              <ng-container [ngTemplateOutlet]="searchbar"></ng-container>
              <ng-container [ngTemplateOutlet]="createButton"></ng-container>
            </div>
          </ion-col>
          <ion-col data-cy="all-inventories-completed-column" size="3">
            <ng-container [ngTemplateOutlet]="completedToggle"></ng-container>
          </ion-col>
        </ion-row>
        <!-- Inventory Cards -->
        <app-inventory-section-desktop
          *ngIf="(platformService?.isTouchExperience$ | async) === false"
          [sectionHeaders]="allInventoriesPageData?.inventoriesSort?.inventories?.headers"
          [selectedHeader]="allInventoriesPageData?.inventoriesSort?.inventories?.selectedHeader"
          [inventories]="allInventoriesPageData?.inventories"
          [isInventoryLanding]="false"
          [searchKey]="searchKey"
          (openWorksheetEmitter)="goToInventoryWorksheet($event)"
          (updateSortEmitter)="updateSort($event)"
          (inventoryEllipsisEmitter)="openInventoryCardEllipsis($event, allInventoriesPageData)"
          (copyInventoryEmitter)="copyInventory($event)"
        >
        </app-inventory-section-desktop>
        <app-inventory-section-tablet
          *ngIf="(platformService?.isTouchExperience$ | async)"
          [sectionHeaders]="allInventoriesPageData?.inventoriesSort?.inventories?.headers"
          [selectedHeader]="allInventoriesPageData?.inventoriesSort?.inventories?.selectedHeader"
          [inventories]="allInventoriesPageData?.inventories"
          [isInventoryLanding]="false"
          [searchKey]="searchKey"
          (openWorksheetEmitter)="goToInventoryWorksheet($event)"
          (updateSortEmitter)="updateSort($event)"
          (inventoryEllipsisEmitter)="openInventoryCardEllipsis($event, allInventoriesPageData)"
          (copyInventoryEmitter)="copyInventory($event)"
        >
        </app-inventory-section-tablet>
      </ng-container>

      <!-- Mobile -->
      <ng-template #mobileAllInventories>
        <!-- Searchbar -->
        <ion-row data-cy="all-inventories-search-row">
          <ion-col data-cy="all-inventories-search-column" size="12">
            <ng-container [ngTemplateOutlet]="searchbar"></ng-container>
          </ion-col>
        </ion-row>
        <!-- Create New Inventory Button, View Completed Toggle -->
        <ion-row
          data-cy="all-inventories-create-completed-row"
          class="all-inventories-create-completed"
        >
          <ion-col data-cy="all-inventories-create-column" size="6.75">
            <ng-container [ngTemplateOutlet]="createButton"></ng-container>
          </ion-col>
          <ion-col data-cy="all-inventories-completed-column" size="5.25">
            <ng-container [ngTemplateOutlet]="completedToggle"></ng-container>
          </ion-col>
        </ion-row>
        <!-- Inventory Cards -->
        <app-inventory-section-mobile
          *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
          [inventories]="allInventoriesPageData?.inventories"
          [isInventoryLanding]="false"
          [searchKey]="searchKey"
          (openWorksheetEmitter)="goToInventoryWorksheet($event)"
          (updateSortEmitter)="updateSort($event)"
          (inventoryEllipsisEmitter)="openInventoryCardEllipsis($event, allInventoriesPageData)"
        >
        </app-inventory-section-mobile>
      </ng-template>
    </ion-grid>

    <app-footer></app-footer>
  </cdk-virtual-scroll-viewport>
</ion-content>

<!-- Searchbar -->
<ng-template #searchbar>
  <ion-searchbar
    data-cy="all-inventories-searchbar"
    class="search"
    mode="md"
    placeholder="{{ 'i18n.inventory.searchWithinInventoryList' | translate }}"
    [(ngModel)]="searchKey"
    (ionInput)="search()"
  ></ion-searchbar>
</ng-template>

<!-- Create New Inventory Button -->
<ng-template #createButton>
  <ion-button
    data-cy="all-inventories-create-button"
    class="usf-outline-green-button"
    (click)="goToCreateInventory()"
  >
    <ion-icon
      data-cy="all-inventories-create-button-icon"
      name="add-outline"
      slot="start"
    >
    </ion-icon>
    {{ 'i18n.inventory.createInventoryTitle' | translate}}
  </ion-button>
</ng-template>

<!-- View All Completed Toggle -->
<ng-template #completedToggle>
  <ion-item
    data-cy="all-inventories-completed-toggle-section"
    class="all-inventories-toggle"
    lines="none"
  >
    <ion-label
      data-cy="all-inventories-completed-toggle-text"
      class="ion-text-right"
      aria-labelledby="view-all-completed"
    >
      {{ 'i18n.inventory.viewAllCompleted' | translate }}
    </ion-label>
    <ion-toggle
      id="view-all-completed"
      data-cy="all-inventories-completed-toggle"
      mode="ios"
      slot="end"
      [checked]="(inventoryOptions$ | async).showCompleted"
      (ionChange)="toggleShowCompleted($event)"
    >
    </ion-toggle>
  </ion-item>
</ng-template>
